import { Workflow, WorkflowTemplate } from "@amzn/finspace-service-typescript-client";
import { ROUTES } from "../constants";
import { ReportAnalyticsType, WorkflowAction } from "../config/dashboard";

export const filterWorkflowsByTag = (workflows: Workflow[], tag?: string): Workflow[] => {
  return tag ? workflows.filter(workflow => workflow.tags?.[0] === tag) : workflows;
};

export const transformWorkflowTemplate = (workflow: WorkflowTemplate): ReportAnalyticsType => {
  // Extract workflowId from tags or use name as fallback
  const workflowId = workflow.tags?.[0] || workflow.name || "UNKNOWN";
  const templateType = workflow.tags?.[0] || "UNKNOWN";
  
  const routeMap: Record<string, { view: string; create: string }> = {
    MFR: { view: ROUTES.MFR_VIEW, create: ROUTES.MFR_CREATE },
    PPM: { view: ROUTES.NETPPM_VIEW, create: ROUTES.NETPPM_CREATE },
    RVM: { view: ROUTES.RVM_VIEW, create: ROUTES.RVM_CREATE },
    OPX: { view: ROUTES.OPEX_VIEW, create: ROUTES.OPEX_CREATE },
  };

  const routes = routeMap[workflowId] || { view: '#', create: '#' };

  const workflowActions: WorkflowAction[] = [
    {
      label: "View",
      variant: "secondary" as const,
      route: routes.view,
    },
    {
      label: "Create",
      variant: "primary" as const,
      icon: "add-plus",
      route: routes.create,
    },
  ];

  return {
    workflowName: workflow.name || "Untitled Workflow",
    workflowId: workflowId,
    workflowShortName: workflowId,
    workflowDescription: workflow.description || "No description available",
    workflowActions,
    disabled: false,
  };
};
